<template>
  <div class="accordion-flush" id="questionAccordion">
    <!--fixa template för loopen-->

    <div class="accordion-item" v-for="(q, i) in questions" :key="i" :id="q.id" style="scroll-margin-top: 30px" :class="{ 'border-top': i !== 0 }">
      <h4 class="accordion-header mb-0 d-flex justify-content-between align-items-center" :id="'heading' + q.id">
        <div
          class="accordion-button collapsed px-0 py-3"
          type="button"
          data-bs-toggle="collapse"
          :data-bs-target="'#collapse-' + q.id"
          aria-expanded="false"
          :aria-controls="'collapse-' + q.id">
          <div>
            <div v-html="q.title.rendered"></div>
            <br />
            <small class="fw">Senast uppdaterad: {{ q.modified.slice(0,10)  }}</small>
          </div>
        </div>
        <div v-if="site == 'cockpit'" class="d-flex flex-column w-25 align-items-end">
          <div>
            <img
            v-if="q.acf.site.indexOf('glimten') != -1"
            height="24"
            width="24"
            title="glimten"
            src="https://cockpit.gavleenergi.se/inc/img/glimten.png" />
          <img v-if="q.acf.site.indexOf('geab') != -1" height="24" width="24" title="geab" src="https://cockpit.gavleenergi.se/inc/img/geab.png" />
          <img v-if="q.acf.site.indexOf('gn') != -1" height="24" width="24" title="gn" src="https://cockpit.gavleenergi.se/inc/img/gn.png" />
          <img v-if="q.acf.site.indexOf('app') != -1" height="24" width="24" title="app" src="https://cockpit.gavleenergi.se/inc/img/app.png" />
          <img
            v-if="q.acf.site.indexOf('cockpit') != -1"
            height="24"
            width="24"
            title="cockpit"
            src="https://cockpit.gavleenergi.se/inc/img/cockpit.png" />
          <button class="btn-sm btn btn-light ml-2" @click="copy(q.id)"><i class="far fa-copy" aria-hidden="true"  data-toggle="tooltip" data-placement="top" title="Klicka för att kopiera ID."></i> {{ q.id }}</button>
          </div>
          

         
        </div>
      </h4>
      <div
        :id="'collapse-' + q.id"
        class="accordion-collapse collapse"
        :class="{ show: currentQ ? currentQ.id == q.id : '' }"
        :aria-labelledby="'heading' + q.id"
        data-bs-parent="#questionAccordion">
        <div class="accordion-body">
          <div v-if="site == 'cockpit'">
            <div class="p-4 rounded bg-success-light">
              <strong>Externt svar</strong><br />
              <span v-if="q.content.rendered.length > 0" v-html="q.content.rendered"></span>
              <span v-if="q.content.rendered.length < 1 && q.acf.call_to_action.length < 1">Inget externt svar hittades</span>
              <a v-if="q.acf.call_to_action.length != 0" class="btn btn-primary my-2" target="_blank" :href="q.acf.call_to_action_link">
                {{ q.acf.call_to_action }}</a>
            </div> 

            <div class="my-3 p-4 rounded bg-primary-light">
              <strong>Internt svar</strong> <br />
              <span v-if="q.acf.internal.length > 0" v-html="q.acf.internal"></span>

              <span v-else>Inget internt svar hittades</span>

              <div>
                <strong>Ansvarig: </strong
                  ><span v-for="(personal, j) in q.acf.contacts" :key="j"
                    >{{ j == q.acf.contacts.length - 1 ? personal.user_firstname + ' ' + personal.user_lastname : personal.user_firstname + ' ' + personal.user_lastname + ", " }}
                  </span>
              </div>
            </div>
            <div class="d-flex">        
              <a class="btn btn-sm btn-primary mb-5 mr-1" target="_blank" :href="'//cockpit.gavleenergi.se/wp-admin/post.php?post=' + q.id + '&action=edit'">REDIGERA FAQ</a>
              <a v-if="q.acf.site.indexOf('geab') != -1" class="btn btn-sm btn-primary mb-5 mr-1" @click='copy("https://www.gavleenergi.se/kundservice/?q=" + q.id)'>KOPIERA LÄNK (GEAB)</a>
               <!--<a v-if="q.acf.site.indexOf('gn') != -1" class="btn btn-sm btn-primary mb-5 mr-1" @click='copy("KOPIERA LÄNK (GEAB)")'>KOPIERA LÄNK (GAVLENET)</a>  -->
              <a class="btn btn-sm btn-primary mb-5 mr-1" @click='copy("https://cockpit.gavleenergi.se/?q=" + q.id)'>KOPIERA LÄNK (COCKPIT)</a> 
              <a class="btn btn-sm btn-primary mb-5" target="_blank" :href="'https://simpliform.gavleenergi.se/forms/eCr5uEwTVJH1KYDgnLzv?qID=' + q.id">Skicka in ändringsförslag</a>
               
            <div class="p-2 ml-auto font-weight-normal">
              <i class="fa-solid fa-thumbs-up text-success"></i> {{q.acf.like}}
              <i class="ml-2 fa-solid fa-thumbs-down text-danger"></i> {{q.acf.unlike}}
            </div></div>
    
          </div>

          <div v-else>
            <span v-html="q.content.rendered"></span>
            <a v-if="q.acf.call_to_action.length != 0" class="btn btn-primary mb-2" target="_blank" :href="q.acf.call_to_action_link">{{
              q.acf.call_to_action
            }}</a>
          </div>

          <!-- <Transition name="slide-main">
                    <div :id="'vote-' + q.id" class="bg-white pb-3"><strong class="d-block mb-3">Fick du svar på din
                        fråga?</strong>
                      <div class="d-flex align-items-start justify-content-start">
  
                        <div class="me-1">
                          <a @click="voteForm(q.id, 'like')" class="btn text-white" style="background: #28a745;">
                            <i class="fa-solid fa-thumbs-up"></i></a>
                        </div>
  
  
                        <div><a @click="voteForm(q.id, 'unlike')" class="btn text-white" style="background: #dc3545;"><i
                              class="fa-solid fa-thumbs-down"></i></a></div>
  
                      </div>
                    </div>
                  </Transition>
                  <Transition name="slide-sub">
                    <div :id="'voted-' + q.id" class="d-none"> <strong class='bg-white d-block p-3'>Tack för din
                        feedback!</strong></div>
                  </Transition>-->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    display: {type: String},
    questions: { type: Array },
    currentQ: { type: Object },
    site: { type: String },
  },
  methods: {
    copy(text) {
      navigator.clipboard.writeText(text);
    },
  },
  mounted() {},
};
</script>
